import { useCallback } from 'react';
import { recaptchaService } from '@/services/captcha.service';
import { logger } from '@/lib/logger';

export const useRecaptcha = () => {
  const generateToken = useCallback(async (action: string = 'chat_message'): Promise<string> => {
    try {
      return await recaptchaService.generateToken(action);
    } catch (error) {
      logger.error('Error generating reCAPTCHA token', error, 'useRecaptcha');
      throw error;
    }
  }, []);

  const generateTokenWithFallback = useCallback(async (action: string = 'chat_message'): Promise<{ token: string; version: 'v3' | 'v2' }> => {
    try {
      return await recaptchaService.generateTokenWithFallback(action);
    } catch (error) {
      console.error('Error generating reCAPTCHA token with fallback:', error);
      throw error;
    }
  }, []);

  const generateV2Token = useCallback(async (containerId?: string, targetElement?: HTMLElement): Promise<string> => {
    try {
      return await recaptchaService.generateV2Token(containerId, targetElement);
    } catch (error) {
      console.error('Error generating reCAPTCHA v2 token:', error);
      throw error;
    }
  }, []);

  const isAvailable = useCallback((): boolean => {
    return recaptchaService.isAvailable();
  }, []);

  const hideBadge = useCallback((): void => {
    recaptchaService.hideBadge();
  }, []);

  const showBadge = useCallback((): void => {
    recaptchaService.showBadge();
  }, []);

  const isBadgeHidden = useCallback((): boolean => {
    return recaptchaService.isBadgeHidden();
  }, []);

  return {
    generateToken,
    generateTokenWithFallback,
    generateV2Token,
    isAvailable,
    hideBadge,
    showBadge,
    isBadgeHidden,
  };
}; 